/**
 * unknown型のエラーから、表示可能な文字列メッセージを抽出する汎用関数
 * @param error catchブロックで捕捉されたunknown型のエラー
 * @returns エラーメッセージを表す文字列
 */
const getErrorMessage = (error: unknown): string => {
  if (error instanceof Error) {
    // 標準のErrorオブジェクトの場合 (Error, TypeError, RangeErrorなど)
    return error.message;
  }
  
  if (typeof error === 'string') {
    // 文字列としてスローされた場合
    return error;
  }

  // messageプロパティを持つオブジェクトであるかチェック
  // 例: { message: "何かエラーが発生しました" } のようなカスタムエラーオブジェクト
  if (typeof error === 'object' && error !== null && 'message' in error) {
    const maybeErrorWithMessage = error as { message: unknown };
    if (typeof maybeErrorWithMessage.message === 'string') {
      return maybeErrorWithMessage.message;
    }
  }

  // それ以外の不明な型の場合、JSON.stringifyを試みる
  // ただし、循環参照などがあると失敗するため、try-catchで囲む
  try {
    return JSON.stringify(error);
  } catch (stringifyError) {
    // JSON.stringifyが失敗した場合のフォールバック
    // console.error("エラーオブジェクトの文字列化に失敗しました:", stringifyError); // デバッグ用
    return '不明なエラーが発生しました';
  }
}

export default getErrorMessage;
